import { useMutation } from '@tanstack/react-query';
import { uploadTransferAudio } from 'services/api/WorkflowServiceAPI';
import { queryClient } from 'services/providers/QueryProvider';
import { queryKeys } from '../queryKeys';

export const useUploadTransferAudio = () => {
    const { mutateAsync, ...rest } = useMutation({
        mutationFn: ({ id, file }: { id: string; file: File }) => uploadTransferAudio(id, file),
        // The provider default is retry: 1, but this endpoint validates the bytes
        // and answers 400; re-sending the whole clip just doubles the failure.
        retry: 0,
        onSuccess: (_data, { id }) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.workflowConfig(id) });
            queryClient.invalidateQueries({ queryKey: queryKeys.transferAudio(id) });
        },
    });

    return {
        uploadTransferAudio: mutateAsync,
        ...rest,
    };
};
